export default __webpack_public_path__ + "static/media/ADA.d11358fa.svg";